<template>
  <b-modal v-if="showModal"
           :id="`gemeos_${_uid}`"
           :ref="`gemeos_${_uid}`"
           :hide-header="true"
           :visible="true"
           centered
           size="xl"
           no-close-on-backdrop
           no-close-on-esc
           @ok="modalChanged"
           @hide="modalChanged">
    <div class="px-2">
      <div class="col-sm-5 col-lg-4 p-0">
        <div class="form-group align-items-top">
          <span class="custom-control custom-switch">
            <input id="gemeo_cadastrado"
                   v-model="form.gemeo"
                   class="custom-control-input"
                   name="gemeo_cadastrado"
                   type="checkbox"
                   :value="true"
                   @click="gemeoCadastrado()">
            <label class="custom-control-label label"
                   for="gemeo_cadastrado">Gêmeo já cadastrado</label>
          </span>
        </div>
      </div>
      <div v-if="form.gemeo">
        <div class="form-group">
          <label class="label"
                 for="matriculaSearch">Matrícula</label>
          <div class="row align-items-top">
            <div class="col-5 col-sm-12 col-md-5">
              <div class="form-group m-0">
                <input id="matriculaSearch"
                       v-model="form.matricula"
                       v-validate="`required`"
                       v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                       name="matriculaSearch"
                       :class="{ 'is-invalid': errors.has('matriculaSearch') }"
                       :required="true"
                       type="text"
                       class="form-control form-control-sm"
                       placeholder="0123456789012345678900123456789012">
                <small v-if="errors.has('matriculaSearch')"
                       class="invalid-feedback">{{ errors.first('matriculaSearch') }}</small>
              </div>
            </div>
            <div>
              <button class="btn btn-sm btn-primary px-3"
                      type="button"
                      @click="getNascimento('matricula')">
                Pesquisar matrícula
              </button>
            </div>
          </div>
        </div>

        <div v-if="nascimento && showResult"
             class="form-group px-2">
          <div class="row">
            <div class="col-12">
              <label for="">
                A matrícula retornou o seguinte resultado. Caso não seja o resultado desejado, preencha os campos manualmente.</label>
            </div>
          </div>
          <span class="custom-control custom-radio custom-control-inline">
            <input id="dados"
                   v-model="form.nascimento"
                   class="custom-control-input input-gemeos"
                   checked
                   name="dados"
                   type="radio"
                   :value="nascimento"
                   @change="getDadosGemeos">
            <label class="custom-control-label small-label"
                   for="dados">
              {{ nascimento.registro.pessoa.nome }}.
              {{ nascimento.numero_declaracao_nascido_vivo ? `DNV: ${maskDnv(nascimento.numero_declaracao_nascido_vivo)}.` : '' }}
              {{ nascimento.registro.pessoa.sexo ? `Sexo: ${sexos[nascimento.registro.pessoa.sexo]}.` : '' }}
            </label>
          </span>

          <div class="row mt-2">
            <div class="col-2 col-sm-6 col-md-2">
              <div class="form-group">
                <label class="label"
                       for="gemeoOrdemNasc1">Ordem nasc.</label>
                <input id="gemeoOrdemNasc1"
                       v-model="sendData.ordem_nascimento"
                       v-validate="`required`"
                       :min="1"
                       name="gemeoOrdemNasc1"
                       :class="{ 'is-invalid': errors.has('gemeoOrdemNasc1') }"
                       :required="true"
                       type="number"
                       class="form-control form-control-sm">
                <small v-if="errors.has('gemeoOrdemNasc1')"
                       class="invalid-feedback">{{ errors.first('gemeoOrdemNasc1') }}</small>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-5">
              <div class="form-group">
                <label class="label"
                       for="nomeGemeo1">Nome</label>
                <input id="nomeGemeo1"
                       v-model="sendData.nome"
                       v-uppercase
                       v-validate="`required`"
                       :class="{ 'is-invalid': errors.has('nomeGemeo1') }"
                       :required="true"
                       name="nomeGemeo1"
                       placeholder="Lorenzo Silva"
                       type="text"
                       class="form-control form-control-sm text-uppercase">
                <small v-if="errors.has('nomeGemeo1')"
                       class="invalid-feedback">{{ errors.first('nomeGemeo1') }}</small>
              </div>
            </div>

            <div class="col-12 col-sm-5 col-md-2">
              <div class="form-group">
                <label class="label"
                       :for="`sexoGemeo_${_uid}`">Sexo</label>
                <select :id="`sexoGemeo_${_uid}`"
                        v-model="sendData.sexo"
                        name="sexoGemeo1"
                        class="form-control form-control-sm">
                  <option :value="null">
                    Selecione
                  </option>
                  <option value="I">
                    Indefinido
                  </option>
                  <option value="F">
                    Feminino
                  </option>
                  <option value="M">
                    Masculino
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-4 col-md-3">
              <div class="form-group">
                <label class="label"
                       for="decNascidoVivoGemeo1">Nº Declaração de Nascido Vivo</label>
                <input id="decNascidoVivoGemeo1"
                       v-model="sendData.numero_declaracao_nascido_vivo"
                       v-mask="'99-99999999-9'"
                       v-validate="{ regex: /^\d{2}-\d{8}-\d$|^\d{2}-\d{8}-\d$|^\d{11}$/ }"
                       data-vv-validate-on="change|custom|blur"
                       :class="{ 'is-invalid': errors.has('decNascidoVivo1') }"
                       class="form-control form-control-sm"
                       maxlength="13"
                       name="decNascidoVivo1"
                       placeholder="00‐00000000‐0"
                       type="text"
                       @change="checkDnv">
                <small v-if="errors.has('decNascidoVivo1')"
                       class="invalid-feedback">{{ errors.first('decNascidoVivo1') }}</small>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!nascimento && showResult">
          <p class="p-0 m-0">
            <b>Nenhum resultado encontrado.</b>
          </p>
          <p class="p-0 m-0">
            Talvez este número de matrícula não exista.
          </p>
          <p class="p-0 m-0">
            Desmarque a opção <b>Gêmeo já cadastrado</b> para fazer um novo cadastro de gêmeo.
          </p>
        </div>
      </div>
      <div v-else
           class="row">
        <div class="col-auto">
          <div class="form-group">
            <label class="label"
                   for="gemeoOrdemNasc">Ordem nasc.</label>
            <input id="gemeoOrdemNasc"
                   v-model="sendData.ordem_nascimento"
                   v-validate="`required`"
                   :min="1"
                   name="gemeoOrdemNasc"
                   :class="{ 'is-invalid': errors.has('gemeoOrdemNasc') }"
                   :required="true"
                   type="number"
                   class="form-control form-control-sm">
            <small v-if="errors.has('gemeoOrdemNasc')"
                   class="invalid-feedback">{{ errors.first('gemeoOrdemNasc') }}</small>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-5">
          <div class="form-group">
            <label class="label"
                   for="nomeGemeo">Nome</label>
            <input id="nomeGemeo"
                   v-model="sendData.nome"
                   v-validate="`required`"
                   :class="{ 'is-invalid': errors.has('nomeGemeo') }"
                   :required="true"
                   name="nomeGemeo"
                   placeholder="Lorenzo Silva"
                   type="text"
                   class="form-control form-control-sm text-uppercase">
            <small v-if="errors.has('nomeGemeo')"
                   class="invalid-feedback">{{ errors.first('nomeGemeo') }}</small>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <div class="form-group">
            <label class="label"
                   for="sexoGemeo">Sexo</label>
            <select :id="`sexoGemeo_${_uid}`"
                    v-model="sendData.sexo"
                    name="sexoGemeo"
                    class="form-control form-control-sm">
              <option :value="null">
                Selecione
              </option>
              <option value="I">
                Indefinido
              </option>
              <option value="F">
                Feminino
              </option>
              <option value="M">
                Masculino
              </option>
            </select>
            <small v-if="errors.has('sexoGemeo')"
                   class="invalid-feedback">{{ errors.first('sexoGemeo') }}</small>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label class="label"
                   for="decNascidoVivoGemeo">Nº Declaração de Nascido Vivo</label>
            <input id="decNascidoVivoGemeo"
                   v-model="sendData.numero_declaracao_nascido_vivo"
                   v-mask="'99-99999999-9'"
                   v-validate="{ regex: /^\d{2}-\d{8}-\d$|^\d{2}-\d{8}-\d$|^\d{11}$/ }"
                   data-vv-validate-on="change|custom|blur"
                   :class="{ 'is-invalid': errors.has('decNascidoVivo') }"
                   class="form-control form-control-sm"
                   maxlength="13"
                   name="decNascidoVivo"
                   placeholder="00‐00000000‐0"
                   type="text">
            <small v-if="errors.has('decNascidoVivo')"
                   class="invalid-feedback">{{ errors.first('decNascidoVivo') }}</small>
          </div>
        </div>

        <div v-if="form.gemeo || propData.matricula"
             class="col-12 col-sm-5 col-md-4">
          <div class="form-group">
            <label class="label"
                   for="gemeoMatricula">Matrícula</label>
            <input id="gemeoMatricula"
                   v-model="sendData.matricula"
                   v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                   name="gemeoMatricula"
                   placeholder="0123456789012345678900123456789012"
                   type="text"
                   class="form-control form-control-sm">
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer"
         slot-scope="{ ok, cancel }">
      <button class="btn btn-sm btn-dark mr-2"
              @click="cancel()">
        Voltar
      </button>
      <button class="btn btn-sm btn-primary"
              type="button"
              :disabled="form.gemeo && !sendData.nome"
              @click="saveGemeo(sendData.index >= 0 ? 'updateGemeo' : 'addGemeos')">
        Continuar
      </button>
    </div>
  </b-modal>
</template>
<script>
  // services
  import NascimentoService from "@/services/Registros/Nascimento"
  import ValidateDeclarationService from "@/services/Registros/ValidateDeclarationService"

  /* filters */
  import { maskDnv } from "@/filters/filters"

  export default {
    name: 'FormGemeos',
    props: {
      propData: {type: Object, default: null},
      propShowModal: {type: Boolean, default: false},
      propGemeos: {type: Object, default: null},
      propMatricula: {type: String, default: null},
      propLista: {type: Array, default: () => ([])}
    },
    data () {
      return {
        maskDnv,
        gemeos: {
          valid: 0
        },
        sendData: {
          nome: null,
          sexo: null,
          numero_declaracao_nascido_vivo: null,
          matricula: null,
          ordem_nascimento: 1
        },
        showModal: false,
        showResult: false,
        form: {
          gemeo: false,
          matricula: null,
          nascimento: null
        },
        nascimento: null,
        sexos: {
          'I': 'Indefinido',
          'F': 'Feminino',
          'M': 'Masculino'
        }
      }
    },
    mounted () {
      if (this.propData) this.sendData = { ...this.propData }
      if (this.propGemeos) this.gemeos = this.propGemeos
      this.showModal = this.propShowModal
    },
    methods: {
      modalChanged () {
        this.sendData = {
          nome: '',
          sexo: null,
          numero_declaracao_nascido_vivo: null,
          matricula: null,
          ordem_nascimento: 1
        }

        this.hideModal()
      },
      hideModal () {
        this.$emit('hideModal')
      },
      async saveGemeo (methodNameEmit) {
        if (!methodNameEmit || ['updateGemeo', 'addGemeos'].indexOf(methodNameEmit) < 0) return

        const valid = await this.$validator.validateAll()

        if (!valid) return

        if (this.verifyMatricula()) return

        // Como dnv não é obrigatória verificamos se o campo está preenchido, se tiver validamos a dnv
        if (this.sendData.numero_declaracao_nascido_vivo && this.sendData.numero_declaracao_nascido_vivo.length > 0) {
          await this.checkDnv()

          if (!this.sendData.numero_declaracao_nascido_vivo || this.sendData.numero_declaracao_nascido_vivo.length !== 11) return
        }

        this.sendData.nome = this.sendData.nome.toUpperCase()

        this.$emit(methodNameEmit, this.sendData, (methodNameEmit === 'updateGemeo'))
      },
      async getNascimento () {
        const valid = await this.$validator.validate('matriculaSearch')

        if (!valid) return

        if (this.verifyMatricula()) return

        try {
          loader({active: true})

          const matricula = this.form.matricula.replace(/\ /g,'')

          const res = await NascimentoService.getNascimentoByMatricula(matricula)

          if (res) {
            this.nascimento = res
          } else {
            this.nascimento = null
          }
        } catch (error) {
          this.nascimento = null

          console.error(error)
        } finally {
          this.showResult = true
          loader({active: false})
        }
      },
      getDadosGemeos () {
        const {registro: { matricula, pessoa, local, partes }, numero_declaracao_nascido_vivo, nascimentoInformacao, ordem_nascimento, nascimento_id } = this.form.nascimento

        this.sendData = {
          ...this.sendData,
          nome: pessoa.nome,
          sexo: pessoa.sexo,
          matricula: matricula,
          numero_declaracao_nascido_vivo: numero_declaracao_nascido_vivo,

          // Dados que serão usados caso o usuário não os informe
          pessoa: {
            ...pessoa,
            ordem_nascimento
          },
          local,
          genitores: pessoa.genitores,
          nascimentoInformacao,
          partes,
          ordem_nascimento,
          nascimento_id
        }
      },
      async checkDnv () {
        let { numero_declaracao_nascido_vivo: dnv} = this.sendData

        dnv = dnv ? dnv.replace(/[-]|_/ig, '') : ''

        if (dnv.length !== 11) return

        try {
          loader({ text: 'Validando DNV', active: true })
          const registroId = this.form.gemeo && this.nascimento && this.nascimento.registro_id ? this.nascimento.registro_id : null

          await ValidateDeclarationService.validateDnv(dnv, registroId)
          this.sendData.numero_declaracao_nascido_vivo = dnv
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = e.response.data && e.response.data.message ? e.response.data.message : `D.N.V Número ${dnv} não é válida`
          objSwal.error.html = ''

          this.sendData.numero_declaracao_nascido_vivo = null

          return Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },
      verifyMatricula () {
        if (this.propMatricula) {
          let matricula = this.sendData.matricula ? this.sendData.matricula : this.form.matricula

          matricula = matricula ? matricula.replace(/\ /g,'') : null

          let repetida = this.propMatricula === matricula

          this.propLista.forEach(gemeo => {
            if (!gemeo.matricula) return

            if (gemeo.matricula.replace(/\ /g,'') === matricula) repetida = true
          })

          if (repetida) {
            matricula = null

            objSwal.error.title = ''
            objSwal.error.text = `A matrícula do gêmeo não pode ser a mesma do registrado ou a de outro gêmeo adicionado.`
            objSwal.error.html = ''

            Swal.fire(objSwal.error)

            return repetida
          }
        }
      },
      clearForm () {
        this.form = {
          ...this.form,
          matricula: null,
          nascimento: null
        }
      },
      clearSendData () {
        const sendData = {
          nome: '',
          sexo: null,
          numero_declaracao_nascido_vivo: null,
          matricula: null,
          ordem_nascimento: 1
        }

        this.sendData = this.sendData.index ? { ...this.sendData, ... sendData} : sendData
      },
      gemeoCadastrado () {
        setTimeout(() => {
          if (this.form.gemeo) {
            this.clearSendData()
          } else {
            this.clearForm()
          }
        }, 200)
      }
    }
  }
</script>
<style lang="scss">
  .small-label {
    font-size: 14px !important;
  }
</style>
